import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Shift } from 'src/app/classes/shift';
import { TaskService } from 'src/app/services/task.service';

@Component({
  selector: 'app-change',
  templateUrl: './change.component.html',
  styleUrls: ['./change.component.scss'],
})
export class ChangeComponent  implements OnInit {
  shift!: Shift
  
  fa = fa

  form = new FormGroup({
    type: new FormControl('change_request'),
    task: new FormControl('', [Validators.required]),
    shift_id: new FormControl<number|null>(null, [Validators.required]),
  })

  constructor(public activeModal: NgbActiveModal,
    private taskService: TaskService
  ) { }

  ngOnInit() {
    this.form.controls.shift_id.setValue(this.shift.id)
  }

  send() {
    this.taskService.send(this.form.value).subscribe(_data => {
      alert($localize`Request sent`)
      this.activeModal.close()
    })
  }
}
